import { showLogout } from "../services/dialog-service";
import { AuthenticationStatus, SmokeballAuthenticator } from "../services/smokeball-authenticator";
import { ErrorType } from "./ErrorType";
import { ApiErrorCodes } from "./ApiErrorCodes";

export async function fetchWrapper<TResult = unknown>(
  ...fetchParams: Parameters<typeof fetch>
): Promise<{ result?: TResult; err?: unknown }> {
  try {
    const fetchResult = await fetch(...fetchParams);

    if (!fetchResult.ok) {
      let err: unknown = null;
      const isUnauthorized = fetchResult.status === 401;

      if (isUnauthorized) {
        const authenticator = SmokeballAuthenticator.getSmokeballAuthenticator();
        const authState = await authenticator.getAuthStatus(false);

        if (authState === AuthenticationStatus.LoggedOut) {
          // We are already logged out so don't try to logout again.
          return { err: ErrorType.Unauthorized };
        }

        await showLogout();
        await authenticator.logout(false);
        return { err: ErrorType.Unauthorized };
      }

      let resultObj = null;
      try {
        resultObj = await fetchResult.json();
      } catch {
        // pass
      }

      if (fetchResult.status === 400) {
        // Bad request response.
        // Check if the response contains an error object that has expected error code.
        if (resultObj?.error?.code === ApiErrorCodes.NoMatterPermission) {
          return { err: ErrorType.NoMatterPermission };
        }
      }

      try {
        err = JSON.stringify(resultObj, null, 2);
      } catch {
        // pass
      }

      if (!err) {
        try {
          err = await fetchResult.text();
        } catch {
          // pass
        }
      }

      if (!err) {
        err = "Failed to fetch";
      }

      return { err };
    }

    const result: TResult = await fetchResult.json();
    return { result };
  } catch (e) {
    return { err: e };
  }
}
